import { HttpError } from "@utilities/api";
import type { InteractiveImageGenerationError } from "@ui/components/demos/InteractiveImage";

/**
 * Maps a generation rejection to a `gated` (quota/rate-limit → sign-up CTA) or `retry` card.
 * Pure/React-free so {@link InteractiveImageLive} and its Storybook mirror agree on which
 * `errorType`s are gated; callers pass localised messages to keep it decoupled from next-intl.
 */
export function mapGenerationError(error: unknown, messages: { gated: string; retry: string }) {
  const errorType = error instanceof HttpError ? error.errorType : null;
  const gated = errorType === "quota_exceeded" || errorType === "rate_limited";
  return {
    kind: gated ? "gated" : "retry",
    message: gated ? messages.gated : messages.retry,
  } satisfies InteractiveImageGenerationError;
}
